import type { LucideProps } from 'lucide-react';
import { User } from 'lucide-react';

export default function UserIcon(props: LucideProps) {
  return <User {...props} />;
}
